
import { AfterViewInit, Component, Inject, Input, NgZone, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
@Component({
  selector: 'app-show-location-popup',
  templateUrl: './show-location-popup.component.html',
  styleUrls: ['./show-location-popup.component.css']
})
export class ShowLocationPopupComponent implements OnInit {

  injectedData: any;
  startLat:any;
  startLon:any;


  private map: google.maps.Map | undefined;
  constructor(public dialogRef: MatDialogRef<ShowLocationPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private commonService:CommonService, private ngZone: NgZone) {
      this.injectedData = data;
     }


  ngOnInit(): void {
    this.startLat=this.injectedData.startlatitudelocation
    this.startLon=this.injectedData.startlongitudelocation
  
  }


  

  closeModal(): void {
    this.dialogRef.close();
  }
init()
{
  const destination = new google.maps.LatLng(this.startLat, this.startLon);
      const map = new google.maps.Map(document.getElementById('map'), {
        center: { lat:this.startLat, lng: this.startLon},
        zoom: 11,
      });
}

}
